import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  static targets = ["modal", "copyLabel"]
  static values = { profileUrl: String }

  open() {
    if (this.hasModalTarget) this.modalTarget.showModal()
  }

  close() {
    if (this.hasModalTarget) this.modalTarget.close()
  }

  async copyUrl() {
    try {
      await navigator.clipboard.writeText(this.profileUrlValue)
    } catch {
      // Fallback: élément dans la dialog (body est inert quand modal ouverte)
      const el = document.createElement("textarea")
      el.value = this.profileUrlValue
      el.style.position = "fixed"
      el.style.opacity = "0"
      this.modalTarget.appendChild(el)
      el.select()
      document.execCommand("copy")
      this.modalTarget.removeChild(el)
    }

    if (this.hasCopyLabelTarget) {
      const original = this.copyLabelTarget.textContent
      this.copyLabelTarget.textContent = "Copié !"
      setTimeout(() => { this.copyLabelTarget.textContent = original }, 2000)
    }
  }
}
